import {computed, Injectable} from '@angular/core';
import {AppConfigService} from "../../core/config/config.service";
import {SS_FIDELITY_EVALUATION_ENDPOINT, SsResult, SsResultStatusCode} from "../stockstore-pos/stockstore-pos.types";
import {catchError, Observable, throwError, timeout, TimeoutError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {FidelityData} from "./fidelity.types";

/**
 * Service related to a customer's fidelity functionalities, such as login.
 */
@Injectable({
  providedIn: 'root'
})
export class FidelityService {

  ssLocalEndpoint = computed(() => {
    return AppConfigService.Config()?.endpoints?.kioskPos;
  });

  config = AppConfigService.Config;

  /**
   * Returns true if the kiosk should enable fidelity functionalities, false otherwise
   */
  isFidelityEnabled = computed(() => {
    return this.config()?.features?.fidelityIsEnabled ?? false;
  })

  /**
   * Returns true if the Kiosk should ask the customer for a fidelity card at the beginning of the order, false otherwise.
   */
  shouldDisplayFidelityQuestion = computed(() => {
    return (this.config()?.features?.fidelityIsEnabled && this.config()?.fidelity?.askAtStart) ?? false;
  })

  /**
   * Returns true if the kiosk should manage a customer's fidelity points or if it should ignore them.
   */
  shouldManagePoints = computed(() => {
    return (this.config()?.features?.fidelityIsEnabled && this.config()?.fidelity?.managePoints) ?? false;
  })

  constructor(private httpClient: HttpClient) {
  }

  evaluateCardCode(cardCode: string): Observable<SsResult<any>> {

    //Call any SS to retrieve customer info.
    //As of now, we don't need to call any Cloud API, as everything order-related is performed by SS.
    //prod: this.ssLocalEndpoint() + SS_FIDELITY_EVALUATION_ENDPOINT
    //mock: "http://127.0.0.1:1221/" + SS_FIDELITY_EVALUATION_ENDPOINT
    return this.httpClient.post<SsResult<FidelityData>>(this.ssLocalEndpoint() + SS_FIDELITY_EVALUATION_ENDPOINT, {
      cardCode: cardCode
    })
      .pipe(
        timeout(100000), //10 sec
        catchError(error => {
          if (error instanceof TimeoutError) {
            error = {
              ...error,
              error: {
                statusCode: SsResultStatusCode.ERR_SS_TIMEOUT
              }
            };
          }
          return throwError(() => error);
        })
      );
  }


}
